import { motion } from "framer-motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is grabba?",
    a: "Grabba is a dark, robust whole-leaf tobacco that's crushed or shredded and mixed into a blend for bold flavor and a stronger kick. Hot Packz Grabba is premium crushed grabba from a proprietary blend of hand-picked leaf strains. WARNING: This product contains nicotine, an addictive chemical.",
  },
  {
    q: "What is the difference between grabba and fronto?",
    a: "Fronto refers to whole, premium leaves often used as a wrap, while grabba is leaf that is crushed or shredded to mix into a blend for flavor and strength. Hot Packz Grabba is a crushed loose leaf grabba.",
  },
  {
    q: "How do you use grabba?",
    a: "Sprinkle a small amount of crushed grabba into your blend for added flavor and a slower, more even burn. Grabba is naturally high in nicotine, so start with a small amount.",
  },
  {
    q: "Is Hot Packz Grabba loose leaf?",
    a: "Yes. Hot Packz Grabba is premium crushed loose leaf grabba, packed 25 jars per box, for a smooth smoke with no choke.",
  },
  {
    q: "Where can I buy Hot Packz Grabba near me?",
    a: "Use the store locator to find authorized Hot Packz Grabba retailers near you, including locations in Jacksonville, Wilmington, New Bern and Kinston, NC and Hartford and Bloomfield, CT.",
  },
  {
    q: "Do you offer wholesale grabba for smoke shops?",
    a: "Yes. Retailers can order Hot Packz Grabba wholesale through the Stock Us form. Contact us for volume pricing and distribution information.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq" className="py-24 sm:py-32 bg-surface border-y border-surface-border">
      <div className="mx-auto max-w-3xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-12"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-blaze mb-4">Grabba 101</p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            Know your <span className="text-fire">grabba</span>
          </h2>
          <p className="text-muted-foreground mt-5 text-base sm:text-lg">
            New to crushed grabba loose leaf? Here's the rundown on what it is, how to use it,
            and where to get Hot Packz Grabba.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="border-t border-surface-border" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-surface-border">
                <AccordionTrigger className="font-heading uppercase text-base sm:text-lg tracking-tight text-white hover:no-underline hover:text-blaze py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm sm:text-base leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
